// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IYfGh","colBig":"styles_colBig__2ZaoS","colSmall":"styles_colSmall__2onA1"};